/* eslint no-param-reassign: ["error", { "props": false }] */

import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['selector', 'wrapper']

  declare readonly selectorTargets: HTMLSelectElement[]
  declare readonly wrapperTargets: HTMLElement[]

  connect() {
    this.showOrHide()
  }

  update() {
    this.showOrHide()
  }

  showOrHide() {
    // iterate over all the select menu targets and pull the unhide attributes from any selected options
    let unhideIds: string[] = []

    this.selectorTargets.forEach((el) => {
      const optionEl = el.options[el.selectedIndex]
      unhideIds = unhideIds.concat(
        optionEl.getAttribute('data-unhide')?.split(',') ?? [],
      )
    })

    // iterate over the wrapper targets and show or hide them based on the unhideIds
    this.wrapperTargets.forEach((elem) => {
      if (unhideIds.includes(elem.getAttribute('data-hidden-for') ?? '')) {
        elem.style.display = 'block'
      } else {
        elem.style.display = 'none'
      }
    })
  }
}
